import { AdditionalFieldInput } from "routes/asset-register/plugins/excel-import/additional-field-input"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { Box, Stack, Typography } from "@mui/material"
import { Case, Switch } from "lib/@components/switch"
import { BoundStandardSelector } from "lib/@components/combos/standard-selector"
import { ExtendedSelectRight } from "slot-definitions"

AdditionalFieldInput("rowFilter").plug(<RowPattern />)

const types = [
    { label: "Not Blank", value: "notblank" },
    { label: "List", value: "list" },
    { label: "Reg. Expr.", value: "regex" },
]

function RowPattern({ field }) {
    return (
        <Stack sx={{ width: 1, justifyContent: "stretch", alignItems: "stretch" }}>
            <ExtendedSelectRight.Plug type={field.field}>
                <Box priority={1} minWidth="max-content">
                    <BoundStandardSelector
                        options={types}
                        field={`fields.${field.field}_type`}
                        defaultValue="notblank"
                    />
                </Box>
            </ExtendedSelectRight.Plug>

            <Box width={1} pr={4}>
                <Switch field={`fields.${field.field}_type`} defaultValue="notblank">
                    <Case when="list">
                        <BoundTextField
                            sx={{ mt: 1, mr: 4 }}
                            hiddenLabel
                            label=""
                            size="small"
                            defaultValue=""
                            helperText="Separate values with comma (,)"
                            field={`fields.${field.field}_list`}
                        />
                    </Case>
                    <Case when="regex">
                        <BoundTextField
                            sx={{ mt: 1, mr: 4 }}
                            hiddenLabel
                            helperText={
                                <Typography variant="caption">
                                    A regular expression matching rows to import; see{" "}
                                    <a
                                        target="_blank"
                                        href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions/Cheatsheet"
                                        rel="noreferrer"
                                    >
                                        this guide
                                    </a>
                                    .
                                </Typography>
                            }
                            size="small"
                            defaultValue=".+"
                            field={`fields.${field.field}_extra`}
                            label=""
                            placeholder="Regex or blank for any value"
                        />
                    </Case>
                </Switch>
            </Box>
        </Stack>
    )
}
